import { render } from "./InvoicesTitle.vue?vue&type=template&id=710d162d"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "710d162d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('710d162d', script)) {
    api.reload('710d162d', script)
  }
  
  module.hot.accept("./InvoicesTitle.vue?vue&type=template&id=710d162d", () => {
    api.rerender('710d162d', render)
  })

}

script.__file = "src/views/payments/modules/pageTitles/InvoicesTitle.vue"

export default script